import React, { memo } from 'react';
import { X, Check } from 'lucide-react';
const comparisonRows = [{
  without: 'Mirás las cartas y no sabés por dónde empezar.',
  with: 'Abrís el mazo y sabés exactamente cómo comenzar una lectura.'
}, {
  without: 'Buscás el significado de cada carta en el manual.',
  with: 'Interpretás los mensajes con mayor fluidez e intuición.'
}, {
  without: 'Cada tirada te genera más dudas que respuestas.',
  with: 'Comprendés lo que las cartas quieren mostrarte.'
}, {
  without: 'Pensás que necesitás memorizarlo todo.',
  with: 'Aprendés a interpretar sin depender de la memoria.'
}, {
  without: 'Dudás de tu intuición constantemente.',
  with: 'Confiás cada vez más en tu propia interpretación.'
}, {
  without: 'Aprender Tarot se siente complicado y frustrante.',
  with: 'Aprender Tarot se vuelve un proceso claro, ordenado y disfrutable.'
}];
export function ComparisonTableExtended() {
  return <section className="px-5 relative overflow-hidden" data-id="element-79">
      <div className="max-w-xl mx-auto relative z-10" data-id="element-80">
        <h3 className="text-3xl md:text-4xl font-bold mb-16 text-center text-brand-petroleum tracking-tight" data-id="element-81">
          La diferencia real
        </h3>

        <div className="grid grid-cols-2 gap-6 mb-12" data-id="element-82">
          <div className="text-[10px] font-bold text-brand-medium-grey uppercase tracking-widest flex items-center justify-center gap-3 bg-brand-soft-cream py-4 rounded-2xl border border-brand-petroleum/5 text-center px-4" data-id="element-83">
            <X size={14} className="text-red-400" data-id="element-84" />
            Sin el Método Tarot Listo™
          </div>
          <div className="text-[10px] font-bold text-brand-gold-warm uppercase tracking-widest flex items-center justify-center gap-3 bg-brand-gold-warm/5 py-4 rounded-2xl border border-brand-gold-warm/10 text-center px-4" data-id="element-85">
            <Check size={14} className="text-brand-gold-warm" data-id="element-86" />
            Con el Método Tarot Listo™
          </div>
        </div>

        <div className="space-y-8" data-id="element-87">
          {comparisonRows.map((row, idx) => <div key={idx} className="grid grid-cols-2 gap-8 border-b border-brand-petroleum/5 pb-8 last:border-0" data-id="element-88">
              <p className="text-sm text-brand-medium-grey font-medium leading-relaxed italic pr-4" data-id="element-89">
                {row.without}
              </p>
              <p className="text-sm font-bold leading-relaxed text-brand-petroleum tracking-tight pl-4 border-l border-brand-gold-warm/20" data-id="element-90">
                {row.with}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}